import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import YoutubeVideo from 'components/Motion_Detection/Setup/YoutubeVideoCardSetup';
import PrimaryBox from 'components/Motion_Detection/Setup/720p_Series/PrimaryBox';
import NavButtons from 'components/Motion_Detection/Setup/NavButtons';
import ForumBox from 'components/Motion_Detection/Setup/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  YoutubeVideo,
  PrimaryBox,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};